<template>
  <nav class="level app-levelbar is-hidden-tablet">
    <img src="../../assets/logo-flat.svg" alt="">
    <div class="">
      <button class="icon-button" @click="toggleSidebar({opened: !sidebar.opened})">
        <i v-if="iconDisplayed" class="icon"
           :class="sidebar.opened ? 'fct-admin-icon-times' : 'fct-admin-icon-bars'"></i>
      </button>
    </div>
  </nav>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    components: {},
    data() {
      return {
        list: null
      }
    },
    computed: {
      ...mapGetters({
        sidebar: 'sidebar',
      }),
      iconDisplayed() {
        return this.$route.name !== 'Login'
      }
    },
    methods: {
      ...mapActions([
        'toggleSidebar'
      ])
      // getList() {
      //   let matched = this.$route.matched.filter(item => item.name)
      //   let first = matched[0]
      //   if (first && (first.name !== 'Home' || first.path !== '')) {
      //     matched = [{name: 'Home', path: '/'}].concat(matched)
      //   }
      //   this.list = matched
      // }
    },
    mounted() {
      this.toggleSidebar({opened: false})
    }
  }
</script>

<style scoped lang="scss">
  .level.app-levelbar {
    position: relative;

    display: flex;
    justify-content: space-between;

    padding: 0 23px;

    height: 50px;
    margin: 0;

    background-color: #fff !important;
    box-shadow: 0px 4px 8px rgba(61, 131, 238, 0.07) !important;

    .icon {
      display: inline-block;
      width: 42px !important;
      color: #3d83ee;
    }
  }
</style>
